import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Droplet, Wind, Eye, MessageCircle, Lightbulb } from 'lucide-react';
import api from '../lib/api';

const RITUALS = [
  { key: 'water', icon: Droplet, label: 'Drink a full glass of water', color: '#60A5FA' },
  { key: 'breath', icon: Wind, label: 'Take three deep breaths', color: '#10B981' },
  { key: 'window', icon: Eye, label: 'Look out a window for 30 seconds', color: '#D4AF37' },
  { key: 'text', icon: MessageCircle, label: 'Text one person who loves you', color: '#EC4899' },
  { key: 'light', icon: Lightbulb, label: 'Turn off one light in the room', color: '#F59E0B' },
];

const ClosingRitual = ({ onDone }) => {
  const [chosen, setChosen] = useState(null);

  const handleChoose = (r) => {
    setChosen(r.key);
    api.post('/ritual/log', { ritual: r.key }).catch(() => {});
    // Give the user a beat to see their choice, then advance
    setTimeout(() => onDone(), 1200);
  };

  return (
    <Card
      className="card-surface border-[#D4AF37]/40 bg-gradient-to-br from-[#1a0f2e] to-[#0A0A0A] mb-6"
      data-testid="closing-ritual-card"
    >
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Outfit' }}>
          <span className="text-[#D4AF37]">🕯️</span>
          Before you go, one small thing
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-[#A1A1AA]">
          Pick one physical action. It closes the loop between here and the rest of your day.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {RITUALS.map((r) => {
            const Icon = r.icon;
            const isChosen = chosen === r.key;
            return (
              <button
                key={r.key}
                type="button"
                onClick={() => handleChoose(r)}
                disabled={chosen !== null}
                data-testid={`ritual-${r.key}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-2xl border text-left text-sm transition-all ${
                  isChosen
                    ? 'border-[#D4AF37] bg-[#D4AF37]/10 text-[#F9FAFB]'
                    : chosen
                      ? 'border-[#27272A] bg-[#0A0A0A] text-[#71717A] opacity-40'
                      : 'border-[#27272A] bg-[#0A0A0A] text-[#F9FAFB] hover:border-[#8B5CF6] hover:bg-[#8B5CF6]/10'
                }`}
              >
                <Icon className="w-5 h-5 flex-shrink-0" style={{ color: r.color }} />
                <span>{r.label}</span>
              </button>
            );
          })}
        </div>
        {chosen && (
          <p className="text-center text-xs text-[#D4AF37] italic pt-2" data-testid="ritual-confirmed">
            Beautiful. Go do it.
          </p>
        )}
        <div className="text-center pt-1">
          <button
            type="button"
            onClick={onDone}
            className="text-xs text-[#71717A] hover:text-[#A1A1AA] px-3 py-1"
            data-testid="ritual-skip"
          >
            Skip
          </button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ClosingRitual;
